import { inject, Injectable } from '@angular/core';
import { DataTestService } from '@y42/data-test';
import { DatasourceTableStoreModel } from '@y42/datasource';
import { SqlModelingTableService } from '../datasource-table/sql-modeling-table.service';

@Injectable({ providedIn: 'root' })
export class SqlModelingDataTestService extends DataTestService<DatasourceTableStoreModel> {
  constructor() {
    super(inject(SqlModelingTableService));
  }
}
